import React from 'react';
import styled from 'styled-components';
import ErrorCard from '../ErrorCard';

const Container = styled.div`
  margin: 32px 0;
`;

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const OptionBlock = styled.div`
  position: relative;
  cursor: pointer;
  
  input[type="checkbox"] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
`;

const OptionLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  border: 2px solid ${props => props.$isSelected ? 'var(--zyvgo-primary, #222222)' : 'var(--zyvgo-border, #e1e5e9)'};
  border-radius: var(--zyvgo-radius-md, 8px);
  background-color: ${props => props.$isSelected ? 'var(--zyvgo-primary, #222222)' : '#FFFFFF'};
  color: ${props => props.$isSelected ? '#FFFFFF' : 'var(--zyvgo-text-primary, #222222)'};
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 1rem;
  font-weight: ${props => props.$isSelected ? '600' : '500'};
  
  &:hover {
    border-color: var(--zyvgo-primary, #222222);
    ${props => !props.$isSelected && `
      background-color: rgba(34, 34, 34, 0.02);
    `}
  }
`;

const OptionText = styled.span`
  flex: 1;
`;

const Checkmark = styled.span`
  display: ${props => props.$show ? 'block' : 'none'};
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background-color: #FFFFFF;
  color: var(--zyvgo-primary, #222222);
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
`;

const MultipleChoice = ({ question, value, onChange, error }) => {
  const handleChange = (choice, checked) => {
    const currentValue = Array.isArray(value) ? [...value] : [];
    
    if (checked) {
      if (!currentValue.includes(choice)) {
        onChange([...currentValue, choice]);
      }
    } else {
      onChange(currentValue.filter(item => item !== choice));
    }
  };

  const isSelected = (choice) => {
    return Array.isArray(value) && value.includes(choice);
  };

  return (
    <Container>
      <OptionsContainer>
        {question.answer_choices?.map((choice, index) => {
          const selected = isSelected(choice);
          return (
            <OptionBlock key={index}>
              <input
                type="checkbox"
                name={`question_${question.id}`}
                value={choice}
                checked={selected}
                onChange={(e) => handleChange(choice, e.target.checked)}
                id={`${question.id}_${index}`}
              />
              <OptionLabel 
                htmlFor={`${question.id}_${index}`}
                $isSelected={selected}
              >
                <OptionText>{choice}</OptionText>
                {selected && <Checkmark $show={selected}>✓</Checkmark>}
              </OptionLabel>
            </OptionBlock>
          );
        })}
      </OptionsContainer>
      
      {error && (
        <ErrorCard
          message={error}
          variant="error"
        />
      )}
    </Container>
  );
};

export default MultipleChoice;
